import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IDENTITY_SERVICE_BASE_URL } from "constants";

export const PasswordSetupForm = ({ userInfo, idToken }) => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch(
        `${IDENTITY_SERVICE_BASE_URL}/api/v1/auth/google`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: userInfo.email,
            password,
            idToken,
          }),
        }
      );

      if (!res.ok) throw new Error("Password setup failed");

      const data = await res.json();
      setSuccess(true);

      console.log("Login detais:", data);
      sessionStorage.setItem("authToken", data.accessToken);
      window.location.href = "/";
    } catch (err) {
      console.error(err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (success)
    return (
      <p className="text-success mt-3">
        Password set successfully! Redirecting...
      </p>
    );
  return (
    <form onSubmit={handleSubmit} className="mt-3 w-100">
      <p>Welcome, {userInfo.name}</p>
      <p className="text-muted small">
        Please set a password to complete your first login.
      </p>

      <input
        type="password"
        placeholder="Enter new password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="form-control mb-3"
        required
      />

      {error && <p className="text-danger text-xxs">{error}</p>}

      <Button
        type="submit"
        color="primary"
        variant="success"
        className="mt-3 w-100 btn-lg fw-semibold d-flex align-items-center justify-content-center text-sm"
        style={{
          fontSize: "1.1rem",
          padding: "0.5rem 1.2rem",
          fontWeight: "600",
          textAlign: "center",
        }}
        disabled={loading}
      >
        {loading ? "Setting up..." : "Set Password"}
      </Button>
    </form>
  );
};
